export default "__VITE_ASSET__7irI_mY2__"